import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TractorsProximityWidgetComponent } from './tractors-proximity-widget.component';
import {DxDataGridModule} from 'devextreme-angular';



@NgModule({
  declarations: [TractorsProximityWidgetComponent],
    imports: [
        CommonModule,
        DxDataGridModule
    ],
  exports: [TractorsProximityWidgetComponent]
})
export class TractorsProximityWidgetModule { }
